import config from "../../config";

const DISPUTE_RECOVERY_ORG_IDS = [
  config.paymentcloud.PAYMENTCLOUD_ORG_ID,
  config.paymentcloud.EMS_ORG_ID,
  config.paymentcloud.KURVPAY_ORG_ID,
].map(Number);

export const isDisputeRecoveryVisible = (organizationId) =>
  DISPUTE_RECOVERY_ORG_IDS.includes(Number(organizationId));
